import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {HttpClient,HttpErrorResponse,HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import {BsLocaleService,BsDatepickerConfig,BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';
import {serializeData,headers} from '../postformdata';
import swal from 'sweetalert2';

@Component({
    selector: 'app-dashboard',
    templateUrl: './common-layout.component.html',
    styleUrls: ['./common.component.css']
})

export class CommonLayoutComponent implements OnInit {
    bsConfig2: Partial<BsDatepickerConfig>;
    minMode: BsDatepickerViewMode = 'month';
    public app : any;
    public headerThemes: any;
    public changeHeader: any;
    public sidenavThemes: any;
    public changeSidenav: any;
    public headerSelected: any;
    public sidenavSelected : any;
    public searchActived : any;
    public searchModel: any;
    kpi_value;kpi_month;
    typeOptions=[{label:'NET SALES TARGET',value:'net'},{label:'SALES TARGET',value:'normal'}]; typeValue='';
    username = localStorage.getItem('username')
    useremail = localStorage.getItem('useremail')
    ip = localStorage.getItem('ip')
    storename;budget;thismonthtarget;
    //设置多语言
    constructor(
        public translate: TranslateService,
        private http:HttpClient,
        private router: Router,
        private cookie:CookieService
    ) 
    {
        translate.addLangs(["zh", "en"]);
        translate.setDefaultLang('zh');

        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/zh|en/) ? browserLang : 'zh');

        this.app = {
            layout: {
                sidePanelOpen: false,
                isMenuOpened: false,
                isMenuCollapsed: true,
                themeConfigOpen: false,
                rtlActived: false,
                searchActived: false
            }
        };  

        //set themes
        this.headerThemes = ['header-default', 'header-primary', 'header-info', 'header-success', 'header-danger', 'header-dark'];
        this.changeHeader = changeHeader;
    
        function changeHeader(headerTheme) {
            this.headerSelected = headerTheme;
        }
    
        this.sidenavThemes = ['sidenav-default', 'side-nav-dark'];
        this.changeSidenav = changeSidenav;
    
        function changeSidenav(sidenavTheme) {
            this.sidenavSelected = sidenavTheme;
        }
    }


    storeOptions: any = [];
    
    storeValue: any = '';


    public menu = ["modifyTarget","modifyBudget"]
    ngOnInit(){
        this.http.get('assets/datas/allapi.json').subscribe(data =>{

            for(let api of data[Symbol.iterator]()){
              this.menu.push(api['key'])
              try{
                for(let sonapi of api['children']){
                  this.menu.push(sonapi['key'])
                }
              }
              catch{}
            }
        })

        this.http.post(this.ip+"/user/getpermissionbyemail/",serializeData({email:this.useremail}),headers).subscribe(res=>{
            var permission = JSON.parse(res['data']['permission'])
            for(let i of this.menu){
                try{
                    if(i=='ExchangePage'){
                        
                    }
                    if(permission.indexOf(i)==-1){
                        document.getElementById(i).style.display='none'
                    }
                    else{
                        document.getElementById(i).style.display='block'
                    }
                }catch{
                    continue
                }
            }

        })
        this.http.post(this.ip+"/dashboard/getallstore/",{},headers).subscribe(res=>{
            for (let s of res['data']){
                this.storeOptions.push({label:s,value:s})
            }
                 
        })
        
        var title = localStorage.getItem('title')
        var patt1=new RegExp("OMS-(.*)");
        this.storename = patt1.exec(title)[1]
        this.bsConfig2 = Object.assign({}, {showWeekNumbers:false,containerClass: 'theme-blue',minMode:this.minMode,dateInputFormat: 'YYYY-MM',});
        
    }

    gettarget(month){
        var kpimonth = month.replace('-','')    
        var data = {'store':this.storeValue.replace('_global',''),'month':kpimonth,'kpi_type':this.typeValue}
        this.http.post(this.ip+"/dashboard/getmonthtarget/",serializeData(data),headers).subscribe(res=>{
            this.thismonthtarget = res['data']['thismonth']
        })
    }

    onValueChange(value: Date): void {
        if(value.getMonth()<9){
            var month = value.getFullYear() + '-0' + (value.getMonth() + 1)
        }
        else{
            var month = value.getFullYear() + '-' + (value.getMonth() + 1)
        }

        this.gettarget(month)
    }

    //登出
    logout = function() {
        this.http.get(this.ip+"/user/logout/",{withCredentials: true}).subscribe(data =>{
            localStorage.removeItem('username')
            localStorage.removeItem('useremail') 
            localStorage.removeItem('store')
            this.cookie.deleteAll()
            this.router.navigate(['/authentication/sign-in'])
        })

    };

    modifytarget = function(month,value){    
        var kpimonth = month.replace('-','')    
        var data = serializeData({"kpi_month":kpimonth,"kpi_value":value,'kpi_store':this.storeValue,'kpi_type':this.typeValue})
        this.http.post(this.ip+"/dashboard/modifytarget/",data,headers).subscribe(res=>{
            swal(res['msg'])
            this.cleartarget()
        })

    }
    cleartarget(){
        this.storeValue=""
        $("input[name='target']").each(function(){
            $(this).val('')
        })

    }
    clearbudget(){
        this.singleSelectValue=""
        $("input[name='budget']").each(function(){
            $(this).val('')

        })

    }

    getbudget = function(){
        var data = serializeData({"channel":this.singleSelectValue})
        this.http.post(this.ip+"/dashboard/getmonthbudget/",data,headers).subscribe(res=>{         
            this.budget = res['data']
        })
            
        
    }
  
    modifybudget = function(value){   
        var data = serializeData({"channel":this.singleSelectValue,"budget":value})
        this.http.post(this.ip+"/dashboard/modifybudget/",data,headers).subscribe(res=>{
            swal(res['msg'])
            this.clearbudget()
        })

    }

    singleSelectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label'],
        maxItems: 1

    };
    //状态选择
    singleSelectOptions: any = [
        {
            label: 'ZZ',
            value: 'zz'

        },
        {
            label: 'PXB',
            value: 'pxb'
        },
        {
            label: 'ZTC',
            value: 'ztc'
        }

    ];
    singleSelectValue: any = '';

    // 运费录入
    clearcarriage(){
        this.storeValue=""
        $("input[name='carriage']").each(function(){
            $(this).val('')

        })
    }

    modifycarriage(month,value){
        month = month.replace('-','')  
        var data = serializeData({"market_type":this.storeValue,"carriage":value,'month':month})
        this.http.post(this.ip+"/dashboard/modifycarriage/",data,headers).subscribe(res=>{
            swal(res['msg'])
            this.clearcarriage()
        })
    }


}